import { render, staticRenderFns } from "./CurriculumCreation.vue?vue&type=template&id=9ccac942&scoped=true&lang=pug"
import script from "./CurriculumCreation.vue?vue&type=script&lang=js"
export * from "./CurriculumCreation.vue?vue&type=script&lang=js"
import style0 from "./CurriculumCreation.vue?vue&type=style&index=0&id=9ccac942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccac942",
  null
  
)

export default component.exports